import React from "react";
import { Modal, Button, Form, Input, message } from "antd";
import "./../../src/index.css";
import bookingService from "../services/booking.service";

export default function CancelReservationModal({ isModalOpen, handleCancelModal, handleFormSubmit }) {
    const [form] = Form.useForm();


    const onFinish = (values) => {

        bookingService.rejectReservationByClient(values.reservationCode)
            .then((response) => {
                if (response.status === 200) {
                    message.success("Uspješno ste poslali zahtjev za otkazivanje rezervacije");
                }
            })
            .catch((err) => {
                message.error("Greška prilikom otkazivanja rezervacije")
                console.log(err);
            })
        handleCancelModal();
    }

    return (
        <Modal
            open={isModalOpen}
            onCancel={handleCancelModal}
            footer={null}
            closable={false}
            className="custom-modal relative z-50 md:pt-20 "
            width={750}
        >
            <div className="w-full flex flex-col gap-4 max-h-screen pt-8">
                {/* First row */}
                <div className="w-full text-center justify-center items-center pb-4">
                    <p className="text-2xl lg:text-3xl font-bold text-footerBlue">
                        {" Otkazivanje rođendana"}
                    </p>
                    <label className="block text-footerBlue font-semibold text-xl lg:py-4 ">
                        Unesite kod koji ste dobili prilikom rezervacije rođendana.
                    </label>
                </div>
                {/* Second row */}
                <div className="w-full text-center justify-center items-center pb-4">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        className="w-full max-w-[900px]"
                    >


                        <Form.Item
                            name="reservationCode"
                            rules={[{ required: true, message: "Ovo polje je obavezno!" }]}

                        >
                            <Input
                                className="h-12 text-lg font-semibold text-center mb-1 bg-formBackgroundGray placeholder-formPlaceholdersGray text-formPlaceholdersGray rounded-[13px]"
                                placeholder="npr. 321890412312"
                            />
                        </Form.Item>
                        <label className="block text-footerBlue font-semibold text-xl lg:py-4 text-left pb-6 ">
                            Nakon otkazivanja rođendana, termin koji ste odabrali biće opet dostupan za rezervaciju od strane drugih osoba.
                        </label>
                        <label className="block text-footerBlue font-semibold text-xl lg:py-4 text-left pb-6">
                            Termin nije moguće otkazati preko platforme,  ako je do rođendana ostalo manje od 15 dana.
                        </label>
                        <Form.Item>
                            <Form.Item>
                                <Button
                                    htmlType="submit"
                                    type="submit"  // Change this line
                                    className="px-10 py-6 rounded-[30px] font-bold text-lg md:text-xl bg-buttonYellow text-footerBlue hover:bg-footerBlue hover:text-white"
                                >
                                    OTKAŽI REZERVACIJU
                                </Button>
                            </Form.Item>
                        </Form.Item>

                    </Form>
                </div>

            </div>
        </Modal>
    );
}
